// Legacy desktop breakpoint mirroring `$md: 992px` in scss/includes/_variables.scss
// (also marked deprecated there). Page-layout callers (currently `isMobile()`) still
// rely on it because the page collapses to single-column at 992. Should be migrated
// to 1024 alongside the SCSS deprecation cleanup.
const _LEGACY_DESKTOP_BREAKPOINT = 992;

export const DESKTOP_BREAKPOINT_QUERY = '(min-width: 1024px)';

export const isLandscape = () => window.innerWidth > window.innerHeight;
export const isMobile = () => window.innerWidth < _LEGACY_DESKTOP_BREAKPOINT;
export const isMobileLandscape = () => isMobile() && isLandscape();
export const isDesktop = () => window.matchMedia(DESKTOP_BREAKPOINT_QUERY).matches;
